<div class="unauthorized-container">
  <h1>Access denied</h1>
  <p>You do not have permission to view this page.</p>
</div>
